import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}'),
    liveOpen: false,
    cartCount: 0
  },
  getters: {
    isLogin: state => !!state.userInfo.id
  },
  mutations: {
    SET_USER_INFO(state, info) {
      state.userInfo = info
      localStorage.setItem('userInfo', JSON.stringify(info))
    },
    SET_LIVE_OPEN(state, open) {
      state.liveOpen = open
    },
    SET_CART_COUNT(state, count) {
      state.cartCount = count
    },
    LOGOUT(state) {
      state.userInfo = {}
      localStorage.removeItem('userToken')
      localStorage.removeItem('userInfo')
    }
  },
  actions: {
    // 获取直播状态
    async getLiveStatus({ commit }) {
      try {
        const res = await Vue.prototype.$http.get('/api/live/status')
        commit('SET_LIVE_OPEN', !!res.data)
      } catch (e) {
        commit('SET_LIVE_OPEN', false)
      }
    }
  },
  modules: {
  }
})
